module.exports = __webpack_public_path__ + "static/media/IntroDemo09-blank.cddb3d10.png";